import { render, staticRenderFns } from "./wapBottom.vue?vue&type=template&id=480ec4ae&scoped=true"
import script from "./wapBottom.vue?vue&type=script&lang=js"
export * from "./wapBottom.vue?vue&type=script&lang=js"
import style0 from "./wapBottom.vue?vue&type=style&index=0&id=480ec4ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480ec4ae",
  null
  
)

export default component.exports